module.exports = __webpack_public_path__ + "static/media/2-option5-4row.ff3bbd8a.png";